<template>
    <div class="formItem" :class="{formError: error}">
        <label v-if="!onlyField">{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <v-select
                v-if="multiple === true"
                hide-details
                class="sr-select"
                :items="validItems"
                v-model="localValue"
                @input="valueChanged"
                item-text="label"
                item-value="value"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
                chips
                multiple
                :menu-props="{'max-width': 290}"
        >
            <template slot="item" slot-scope="data">
                <checkbox :value="localValue.includes(data.item.value)"
                          @input="changeCheckboxValue(data.item.value)"
                          :label="data.item.label"
                          class="sr-checkbox">
                </checkbox>
            </template>
        </v-select>
        <v-select
                v-else
                hide-details
                class="sr-select"
                :items="validItems"
                v-model="localValue"
                @input="valueChanged"
                item-text="label"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
                item-value="value"
                :menu-props="{'max-width': 290}"
        ></v-select>
    </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Array, Object, String, Number],
        default: () => []
      },
      onlyField: {
        type: Boolean,
        default: false
      },
      limit: {
        type: Number,
        default: 1
      },
      items: {
        type: Array,
        required: true
      },
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      subLabel: {
        type: String,
        default: ''
      }
    },
    methods: {
      /**
       * Change the value of the Checkbox
       *
       * @param {Number} id
       */
      changeCheckboxValue (id) {
        let index = this.localValue.indexOf(id)
        if (index > -1) {
          // remove it from array
          this.localValue.splice(index, 1)
        } else {
          // add it to array
          this.localValue.push(id)
        }
      },
      /**
       * Value change of the v-select
       *
       * @param {Number[]}    value      the ids of the selected items
       */
      valueChanged (value) {
        // check for limit
        if (this.multiple === true && this.limit && value.length > this.limit) {
          value.pop()
        }

        this.$emit('input', value)
      }
    },
    computed: {
      /**
       * Get all items and check for their "disabled" state
       *
       * @return {{value: String, label: String, disabled: Boolean}[]}
       */
      validItems () {
        const items = this.items
        if (this.limit && Array.isArray(this.localValue) && this.limit === this.localValue.length) {
          // disable all other items if the limit is reached
          items.forEach(el => {
            el.disabled = this.localValue.includes(el.value) === false
          })
        } else {
          // no limit, enable all items just in case the limit changes
          items.forEach(el => {
            el.disabled = false
          })
        }

        if (!this.multiple) {
          return [{ value: null, label: '' }, ...items]
        } else {
          return items
        }
      },
      localValue: {
        get () {
          if (this.multiple) {
            if (this.value instanceof Array) {
              return this.value
            }

            return this.value ? [this.value] : []
          }

          if (this.value instanceof Array) {
            return this.value[0]
          }

          return this.value ? this.value : ''
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      multiple () {
        return this.limit === 0 || this.limit > 1
      }
    },
    name: 'Dropdown'
  }
</script>

<style scoped>

</style>
